import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-bookmark-icon',
  templateUrl: './general-bookmark.component.html'
})
export class GeneralBookmarkComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
